import styled from "styled-components"

const NavbarStyles = styled.nav`
  a {
    text-decoration: none;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 250px;
  }
  .logo {
    cursor: pointer;
    width: 90px;
  }
  .nav-area {
    list-style: none;
    & li {
      display: inline-block;
      padding: 0 15px;

      & a {
        transition: 0.3s;
        color: ${({ theme }) => theme.colors.lightColor};
        font-size: 18px;
        letter-spacing: 0px;
        line-height: 26px;
        font-weight: 500;
        text-align: center;
        :hover {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }
  .btn-area {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn-contact {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid #fff;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 4px;
    padding-bottom: 4px;
    overflow: hidden;
  }
  .btn-login {
    height: 30px;
    width: 90px;
    border-radius: 2px;
    text-align: center;
    background-color: #fff;
    color: #5a8d52;
    font-size: 16px;
    border: none;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .barsMenu {
    display: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid #fff;
    padding-left: 14px;
    padding-right: 14px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  ${({ theme: { down } }) => down("1260px")} {
    .nav-area {
      display: none;
    }
    .btn-area {
      display: none;
    }
    .barsMenu {
      display: block;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.lg)} {
    header {
      padding: 10px 100px;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    header {
      padding: 10px 50px;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    header {
      padding: 10px 10px;
    }
  }
`

export default NavbarStyles
